export const MESSAGES = {
    SOMETHING_WRONG: 'Something went wrong',
    UNFILLED_SURVEY: 'One or more questions are unanswered, please answer them to continue'
}